var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A0A9BE",
  fillRule: "evenodd",
  d: "M12.087 2.667a3.18 3.18 0 0 1 3.18 3.18v3.86a3.18 3.18 0 0 1-3.18 3.18h-8.24a3.18 3.18 0 0 1-3.18-3.18v-3.86a3.18 3.18 0 0 1 3.18-3.18zM6.78 9.773l3.287-1.8c.146-.08.173-.293.026-.373L6.78 5.7c-.14-.08-.273.02-.273.187v3.7c0 .16.133.266.273.186",
  clipRule: "evenodd"
})));
export default SvgVideo;